/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.orders.detail.forms.print.controllers', [
  'acme.common.service.helpers'
])

.controller('OrdersDetailFormsPrintController', ['$scope', '$document', '$timeout', '$filter', 'HelpersService', 'CalendarService', 'ResponseData', function($scope, $document, $timeout, $filter, HelpersService, CalendarService, ResponseData) {

    $scope.ordersDetailFormsPrint = {

      model: {
        headerData: [],
        col1: [],
        col2: []
      },

      form: {},
      eventDate: '',
      displaySubmittedOn: '',

      init: function() {
        if (ResponseData.data && ResponseData.data.success) {
          this.form = ResponseData.data.payload;
          this.eventDate = $filter('date')(CalendarService.parseDate(this.form.eventStartTime), HelpersService.dateFormats.standardDateTime);

          this.model.headerData = {
            formName: this.form.formName,
            formNumber: this.form.formNumber,
            itemName: this.form.itemName,
            eventDate: this.eventDate,
            submissionDate: ''
          };
        }

        if(this.form.formResponseData) {
          this.model.headerData.submissionDate = $filter('date')(CalendarService.parseDate(this.form.formResponseData.submissionDate), HelpersService.dateFormats.shortDateTime);
          if (this.form.formResponseData.hasOwnProperty('responseData') &&
            this.form.formResponseData.responseData &&
            this.form.formResponseData.responseData.hasOwnProperty('fields') &&
            this.form.formResponseData.responseData.fields instanceof Array &&
            this.form.formResponseData.responseData.fields.length) {
            this.processResponseData(this.form.formResponseData.responseData.fields);
          }
        }

        $scope.$on('$destroy', $scope.$on('AppController::print', function(e, data) {
          $scope.ordersDetailFormsPrint.printPage();
        }));
      },

      processResponseData: function (responseData) {
        var col1,
            col2;

        if(responseData.length % 2) {
          col1 = responseData.slice(0, Math.ceil(responseData.length/2));
          col2 = responseData.slice(Math.floor(responseData.length/2) + 1, responseData.length);
        } else {
          col1 = responseData.slice(0, Math.ceil(responseData.length/2));
          col2 = responseData.slice(Math.floor(responseData.length/2), responseData.length);
        }

        this.model.col1 = col1;
        this.model.col2 = col2;
      },

      printPage: function() {
        var printArea = $document.find('.orders-detail-forms-print'),
          areaClone = printArea.clone(),
          // summary = areaClone.find('.orders-detail-forms-detail-header'),
          // eventInfo = areaClone.find('.orders-detail-forms-detail-event-info'),
          // responseData = areaClone.find('.orders-detail-forms-detail-response-data'),
          styles = '<style type="text/css">html, body { width: 100%;  @media print { @page { margin: 0; } } }</style>';

        areaClone.addClass('printable');
        areaClone.css({
          height: 'auto',
          width: '100%'
        });

        areaClone.find('.orders-detail-forms-detail-header').clone();

        areaClone.print({
          append: styles,
          renderTimeout: 500
        });
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.ordersDetailFormsPrint.init();

}]);